import { defineComponent as _defineComponent } from 'vue'
import type { OpenEndedQuestion } from '@ilteducation/exercise-service-types';

type Props = {
  index: number;
  parentSource: string;
  resource: string;
  item: OpenEndedQuestion;
  preview: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenEndedQuestion',
  props: {
    index: null,
    parentSource: null,
    resource: null,
    item: null,
    preview: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})